import "./Accueil.css";
import React, { Component } from "react";
import SearchBar from "../SearchBar/SearchBar";
import GrowthIcon from "../Commands/GrowthIcon/GrowthIcon";
import DateTime from "../Commands/DateTime/DateTime";
import Demo from "../Connexion/Demo/Demo";

export default function Accueil () {
  const meta = {properties: {
    text: {value: "",  control:"TextBox"},
    date: {value: true,  control:"CheckBox"},
    dateFormat: {value: "dd/mm/yyyy"},
    time: {value: true,  control:"CheckBox"},
    timeFormat: {value: "hh:mm:ss"},
    
  }};

  const getStyle = (meta) => {
       
    return {
      fontSize: {value:"14px"},
      fontFamily: {value:"Arial"},
      color: {value:"#212121"},
      height: {value:"25px"},
      width: {value:"170px", hide:true},
      display: {value:"flex", hide:true},
      alignItems: {value:"center", hide:true},
     
      left: {value:10, hide:true},
      top: {value:50, hide:true},
      boxSizing: {value:"border-box", hide:true},
      resize: {value:"both", hide:true},
      overflow: {value:"auto", hide:true},
    }
  };
 /*
 <div
          style={{
           
            fontFamily:"Garamond",
            color:"#008dff",

            marginTop:"100px",
            width:"300px",
            display:"flex",
            marginLeft:"auto", 
            marginRight:"auto", 
            borderRadius: "4px",
            backgroundColor: "white",
          }}>
            
          <Demo />
        </div>

 */
 
    return (
      <div style={{display:"flex"}}>
        
        <div
          style={{
            textAlign:"center",
           
            
            fontSize:"0px",
            minHeight:"500px",
           
            
            marginLeft:"auto", 
            marginRight:"auto", 
          }}>
        <GrowthIcon />
        <div style={{
          
            color:"#084793",
            fontSize:"18px",
            marginTop:"-60px",
            marginLeft:"35px"
            
            
          }} >Speed your growth</div>
      </div>
      
    </div>
    );
  
}
